import { useFont } from '@octane/spark'
import styled from 'styled-components'

export const HeaderTitle = styled.span`
    ${() => useFont('c24', { weight: '800' })};
`

export const HeaderSubtitle = styled.span`
    ${() => useFont('c16', { weight: '400' })};
`

export const FinePrint = styled.div`
    ${() => useFont('c16', { weight: '400' })};
    padding-bottom: 10px;
`

export const FieldStyle = styled.div`
    padding-top: 16px;

    div[id^='wrapper-input'] {
        padding-top: 20px;
    }

    > div:first-child {
        margin-bottom: 10px;
    }
`

export const FormContainer = styled.div`
    margin: auto;
    margin-top: 50px;
`

export const StatusIndicatorStyle = styled.div`
    padding-top: 5px;
`
